import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Box, Grid } from '@mui/material';
import { UserTable } from './table/UserTable';
import { NewUserDialog } from '../new-user/NewUser';
import { ActionCard } from '../../../../components/admin/cards/ActionCard';
import { PageHeader } from '../../../../components/common/header/PageHeader';
import { SearchField } from '../../../../components/common/inputs/SearchField';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { getUserByStatusAsync, getUsersAsync } from '@application/features/adminUsers/adminUserThunk';
import { UserStatus } from '@application/common/enums/user-status';
import { DeclinedUserDialog } from '../declined-user/DeclinedUser';
export const Users = () => {
    const [newUserDialog, setNewUserDialog] = React.useState(false);
    const [declinedUserDialog, setDeclinedUserDialog] = React.useState(false);
    const { getUserDetailsRequest, users, newOrDeclinedUsers } = useAppSelector((state) => state.user);
    const dispatch = useAppDispatch();
    const [searchQuery, setSearchQuery] = useState('');
    const handleSearchChange = (query) => {
        setSearchQuery(query);
    };
    useEffect(() => {
        dispatch(getUsersAsync(getUserDetailsRequest));
    }, [dispatch, getUserDetailsRequest]);
    const getDeclinedUsers = () => {
        dispatch(getUserByStatusAsync(UserStatus.Disapproved))
            .unwrap()
            .then((res) => {
            if (res)
                setDeclinedUserDialog(true);
        });
    };
    const getnewOrDeclinedUsers = () => {
        dispatch(getUserByStatusAsync(UserStatus.Pending))
            .unwrap()
            .then((res) => {
            if (res)
                setNewUserDialog(true);
        });
    };
    return (_jsxs("div", { children: [_jsx(PageHeader, { title: 'Users' }), _jsx(Box, { width: { xs: '97%', sm: '90%', md: '88%', lg: '90%', xl: '88%' }, margin: 'auto', children: _jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { item: true, md: 3, xs: 12, children: _jsxs(Box, { mt: { xs: 0, sm: 0, md: 10, lg: 10 }, children: [_jsx(ActionCard, { subtitle: users ? `All users (${users?.items.length})` : 'All users (0)', color: newUserDialog || declinedUserDialog ? 'secondary' : 'primary', to: '' }), _jsx(ActionCard, { mt: 2, subtitle: newOrDeclinedUsers
                                            ? `New user requests (${users?.items.filter((x) => x.status == UserStatus.Pending).length})`
                                            : 'New user requests (0)', color: newUserDialog ? 'primary' : 'secondary', notification: true, onClick: getnewOrDeclinedUsers }), _jsx(ActionCard, { mt: 2, subtitle: newOrDeclinedUsers
                                            ? `Declined users (${users?.items.filter((x) => x.status == UserStatus.Disapproved).length})`
                                            : 'Declined users (0)', color: declinedUserDialog ? 'primary' : 'secondary', onClick: getDeclinedUsers })] }) }), _jsxs(Grid, { item: true, md: 9, xs: 12, children: [_jsx(SearchField, { fullWidth: true, bgColor: 'white', placeholder: 'Search users', mb: 2, placeholderColor: '#B1B1B1', onSearchChange: handleSearchChange, searchQuery: searchQuery }), _jsx(UserTable, { searchQuery: searchQuery })] })] }) }), _jsx(NewUserDialog, { handleClose: () => setNewUserDialog(false), open: newUserDialog }), _jsx(DeclinedUserDialog, { handleClose: () => setDeclinedUserDialog(false), open: declinedUserDialog })] }));
};
